'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _viewprt = require('viewprt');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LazyVideoSetup = function LazyVideoSetup(el) {
  (0, _classCallCheck3.default)(this, LazyVideoSetup);

  (0, _viewprt.ElementObserver)(el, {
    onEnter: function onEnter(el) {
      new LazyVideo({ el: el });
    },

    once: true
  });
};

exports.default = LazyVideoSetup;

var LazyVideo = function LazyVideo(_ref) {
  var _this = this;

  var el = _ref.el;
  (0, _classCallCheck3.default)(this, LazyVideo);

  this.el = el;
  this.video = this.el.querySelector('video');
  this.loadedClass = 'video-loaded';

  if (!this.video) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) {
    this.video.removeAttribute('autoplay');
    this.video.pause();
  }

  if (this.video.dataset.poster) {
    this.video.setAttribute('poster', this.video.dataset.poster);
  }

  // Process all source elements
  Array.from(this.video.querySelectorAll('source')).forEach(function (videoSource) {
    if (videoSource.dataset.src) {
      videoSource.src = videoSource.dataset.src;
    }
  });

  this.video.load();

  // Add loaded class to parent element
  this.el.classList.add(this.loadedClass);

  // Handle autoplay logic for small devices
  var isSm = window.innerWidth < 768; // Adjust according to your breakpoint definition
  if (isSm || this.video.hasAttribute('autoplay') === false) {
    return;
  }

  if (this.video.paused) {
    var playVideoOnTouch = function playVideoOnTouch() {
      if (_this.video.paused) {
        _this.video.play();
        document.removeEventListener('touchstart', playVideoOnTouch);
      }
    };
    document.addEventListener('touchstart', playVideoOnTouch);
  }
};